import * as React from "react";

const ChevUp = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g>
        <path
          d="M11.9998 10.8004L8.0998 14.7004C7.91647 14.8837 7.68314 14.9754 7.3998 14.9754C7.11647 14.9754 6.88314 14.8837 6.6998 14.7004C6.51647 14.5171 6.4248 14.2837 6.4248 14.0004C6.4248 13.7171 6.51647 13.4837 6.6998 13.3004L11.2998 8.70039C11.4998 8.50039 11.7331 8.40039 11.9998 8.40039C12.2665 8.40039 12.4998 8.50039 12.6998 8.70039L17.2998 13.3004C17.4831 13.4837 17.5748 13.7171 17.5748 14.0004C17.5748 14.2837 17.4831 14.5171 17.2998 14.7004C17.1165 14.8837 16.8831 14.9754 16.5998 14.9754C16.3165 14.9754 16.0831 14.8837 15.8998 14.7004L11.9998 10.8004Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
};

export default ChevUp;
